import { createFileRoute } from '@tanstack/react-router'
import { authClient } from '@/lib/auth'
import { requireAuth } from '@/lib/middleware'
import { Main } from '@/components/layout/main'
import { ReportsConfigurationManager } from '@/features/organizations/settings/reports-configuration'

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/reports-configuration'
)({
  beforeLoad: async () => {
    await requireAuth()
  },
  component: ReportsConfigurationPage,
})

function ReportsConfigurationPage() {
  const { data: activeOrganization, isPending } =
    authClient.useActiveOrganization()

  if (isPending) {
    return (
      <Main>
        <div className="py-8 text-center">
          <p className="text-muted-foreground">Loading organization...</p>
        </div>
      </Main>
    )
  }

  return (
    <ReportsConfigurationManager organizationId={activeOrganization?.id || ''} />
  )
}
